import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tooltip"]

  show() {
    if (this.hasTooltipTarget){
      this.tooltipTarget.style.display = "block"
    }
  }

  hide() {
    if (this.hasTooltipTarget){
      this.tooltipTarget.style.display = "none"
    }
  }
}
